export enum DecisionMode {
    /**
     *   /**
     * Flagship SDK mode decision api
     */
    DECISION_API = 'DECISION-API',

    /**
     * Flagship SDK mode bucketing
     */
    BUCKETING = 'BUCKETING',

    BUCKETING_EDGE = 'BUCKETING_EDGE'
  }
